import { Outlet } from 'react-router-dom'
import PublicHeader from './PublicHeader'
import PublicBottomNav from './PublicBottomNav'

function PublicLayout() {
  return (
    <div className="min-h-screen bg-secondary-50 flex flex-col">
      {/* Header with navigation */}
      <PublicHeader />

      {/* Main content */}
      <main className="flex-1 pb-20 md:pb-0 overflow-y-auto">
        <Outlet />
      </main>

      {/* Bottom navigation (mobile) */}
      <PublicBottomNav />
    </div>
  )
}

export default PublicLayout
